import { TransactionProps } from '../contexts/OneClickBuyContext/types/Payment';
import { onlyNumbers } from '../utils/currency';

export interface BankSlipViewProps {
	digitableLine: string | null;
	dueDate: string | null;
	bankSlipUrl: string | null;
}

export const bankSlipView = (
	transaction: TransactionProps | null,
	orderHash: string | null,
	host: string | null
): BankSlipViewProps => {
	const digits = onlyNumbers(transaction?.bank_slip_code ?? '');

	const derivedUrl = orderHash && host ? `${host}/bankslip/${orderHash}` : null;

	return {
		digitableLine: digits || null,
		dueDate: transaction?.bank_slip_due_date || null,
		bankSlipUrl: transaction?.bank_slip_url || derivedUrl,
	};
};
